export const APP_TOOLTIP_ID = "app-tooltip";
